import {withProps} from 'recompose';

export default withProps(({nameFilter, employeeList}) => ({
  employeeList: nameFilter
    ? employeeList.filter(
        v => v.Name.toLowerCase().indexOf(nameFilter.toLowerCase()) >= 0
      )
    : employeeList
}));
